import { useQuery } from "@apollo/client";
import { GetItemShadesByIdsDocument } from "../../gql/generated/graphql";

interface Props {
  ids: string[];
}

export const useItemShades = ({ ids }: Props) => {
  const { data, loading, error } = useQuery(GetItemShadesByIdsDocument, {
    variables: { ids },
  });

  return {
    itemShades: data?.getItemShadesByIds ?? [],
    isLoading: loading,
    error,
  };
};
